import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ChevronUpIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ChevronUpIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M4 15.5654C4 15.3433 4.08479 15.1211 4.25437 14.9516L11.3861 7.81979C11.7253 7.48064 12.2747 7.48064 12.6139 7.81979L19.7456 14.9516C20.0848 15.2907 20.0848 15.8401 19.7456 16.1793C19.4065 16.5184 18.857 16.5184 18.5179 16.1793L12 9.66138L5.48208 16.1793C5.14293 16.5184 4.59351 16.5184 4.25435 16.1793C4.08478 16.0097 4 15.7876 4 15.5654Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ChevronUpIcon;
